import {message, Modal} from 'antd';
import {errorMessage} from '../common';

interface Options {
    confirmMessage?: string;
    successMessage?: string;
}

type GetOptions<T extends []> = (...args: T) => Options;

const OptionsDefault: Options = {
    confirmMessage: '确定要删除吗?',
    successMessage: '删除成功!',
};

export function useConfirmDelete<T extends (...args: any) => Promise<any>>(
    callback: T,
    options?: Options | GetOptions<Parameters<T>>,
) {
    return async (...args: Parameters<T>) => {
        const innerOptions = Object.assign(
            {},
            OptionsDefault,
            typeof options === 'function' ? options(...args) : options,
        );

        Modal.confirm({
            content: innerOptions.confirmMessage,
            onOk: async () => {
                try {
                    await callback(...args);
                    message.success(innerOptions.successMessage);
                } catch (e) {
                    message.error(errorMessage(e));
                }
            },
        });
    };
}
